var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-btn",
        {
          attrs: {
            color: "success",
            dark: "",
            title: "Notificar seleccionados"
          },
          on: {
            click: function($event) {
              return _vm.abrirCerrarDialog()
            }
          }
        },
        [_c("v-icon", [_vm._v("mail")]), _vm._v("\n    Notificar\n  ")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pb-2" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs9: "" } },
                        [
                          _c("v-icon", [_vm._v("mail")]),
                          _vm._v(" ENVIAR CORREO ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.abrirCerrarDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "justify-center": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { shrink: "" }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "px-3 mb-2 white--text",
                                  attrs: { color: "rgb(87,51,204,0.8)" }
                                },
                                [
                                  _c("span", { staticClass: "caption" }, [
                                    _vm._v("NOTIFICACIONES")
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "display-1" }, [
                                    _vm._v(_vm._s(_vm.lista_correos.length))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.disabled_notificaciones
                            ? _c(
                                "v-flex",
                                { staticClass: "pb-2", attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "p-0 m-0",
                                      attrs: {
                                        color: "#0085AD",
                                        loading: _vm.loading,
                                        dark: "",
                                        block: "",
                                        title: "Notificar"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.notificarCorreo(
                                            _vm.lista_correos
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("mail")]),
                                      _vm._v(
                                        "\n                ENVIAR CORREO\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sw_envio_correos
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _c(
                                  "h4",
                                  { staticClass: "blue--text text-xs-center" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.contador_correos_enviados) +
                                        " correos enviados de\n                " +
                                        _vm._s(_vm.lista_correos.length) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "elevation-1 tabla-comprimida-light",
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.lista_correos,
                                  "no-data-text": _vm.loading
                                    ? "Cargando..."
                                    : "No se tiene registros",
                                  loading: _vm.loading,
                                  "rows-per-page-text": "Filas por pagina",
                                  "rows-per-page-items": [5, 10, 20, 50]
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.nombres) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  color: "indigo lighten-1"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          props.item.correo
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.nombres
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "table",
                                                      [
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v(
                                                              "Nro papeleta"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("th", [
                                                            _vm._v(
                                                              "Fecha desde"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("th", [
                                                            _vm._v(
                                                              "Fecha hasta"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("th", [
                                                            _vm._v("Dias")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("th", [
                                                            _vm._v("Tipo")
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          props.item.papeletas,
                                                          function(
                                                            papeleta,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              { key: index },
                                                              [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "20%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          papeleta.secuencia
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "20%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .$moment(
                                                                              papeleta.fecha_desde
                                                                            )
                                                                            .format(
                                                                              "DD/MM/YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "20%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .$moment(
                                                                              papeleta.fecha_hasta
                                                                            )
                                                                            .format(
                                                                              "DD/MM/YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "20%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          papeleta.total_dias
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "20%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          papeleta.tipo_vacacion
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.correos_enviados.length > 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { shrink: "" }
                                        },
                                        [
                                          _c(
                                            "h3",
                                            { staticClass: "blue--text" },
                                            [_vm._v("Enviados")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "" } },
                                        [
                                          _c(
                                            "v-tooltip",
                                            { attrs: { bottom: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    slot: "activator",
                                                    color: "green",
                                                    outline: "",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.crearExcel(
                                                        _vm.correos_enviados,
                                                        "NOTIFICACIONES ENVIADAS"
                                                      )
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-symbols-outlined"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        table_view\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Exportar Ecxel")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-data-table", {
                                    staticClass:
                                      "elevation-1 tabla-comprimida-light",
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.correos_enviados,
                                      "no-data-text": _vm.loading
                                        ? "Cargando..."
                                        : "No se tiene registros",
                                      loading: _vm.loading,
                                      "rows-per-page-text": "Filas por pagina",
                                      "rows-per-page-items": [5, 10, 20, 50]
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.nombres
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.correo
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      795937717
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.correos_fallidos.length > 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { shrink: "" }
                                        },
                                        [
                                          _c(
                                            "h3",
                                            { staticClass: "blue--text" },
                                            [_vm._v("No Enviados")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "" } },
                                        [
                                          _c(
                                            "v-tooltip",
                                            { attrs: { bottom: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    slot: "activator",
                                                    color: "green",
                                                    outline: "",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.crearExcel(
                                                        _vm.correos_fallidos,
                                                        "NOTIFICACIONES NO ENVIADAS"
                                                      )
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-symbols-outlined"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        table_view\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Exportar Excel")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-data-table", {
                                    staticClass:
                                      "elevation-1 tabla-comprimida-light",
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.correos_fallidos,
                                      "no-data-text": _vm.loading
                                        ? "Cargando..."
                                        : "No se tiene registros",
                                      loading: _vm.loading,
                                      "rows-per-page-text": "Filas por pagina",
                                      "rows-per-page-items": [5, 10, 20, 50]
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.nombres
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.correo
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      795937717
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb26b21a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb26b21a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/components/EnviaCorreoMasivo.vue
// module id = null
// module chunks = 